module.exports = __webpack_public_path__ + "img/79.b5ddbf06.jpg";